module.exports = __webpack_public_path__ + "resources/img/logo_toast_gov_color.5a7ec2a3ece6de907a74c19342d11e63.svg";